import { render, staticRenderFns } from "./StatsKpiColumnData.vue?vue&type=template&id=cd094280&scoped=true&"
import script from "./StatsKpiColumnData.vue?vue&type=script&lang=js&"
export * from "./StatsKpiColumnData.vue?vue&type=script&lang=js&"
import style0 from "./StatsKpiColumnData.vue?vue&type=style&index=0&id=cd094280&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd094280",
  null
  
)

export default component.exports